export default __webpack_public_path__ + "img/folderMono.b79ac6ac.svg";